import { ORDER_STATUS } from '@bagonboard/wiseman';
import {
  always, lensProp, mergeDeepLeft, over,
} from 'ramda';
import actions from '../actions';
import { ASYNC_FETCH_INITIAL_STATE, makeAsyncFetchReducer, makeReducer } from '../utils';

export const INITIAL_STATE = {
  order  : ASYNC_FETCH_INITIAL_STATE,
  update : ASYNC_FETCH_INITIAL_STATE,
  confirm: ASYNC_FETCH_INITIAL_STATE,
  events : ASYNC_FETCH_INITIAL_STATE,
};

const reducer = makeReducer({
  initialState: INITIAL_STATE,
  reducers    : {
    ...makeAsyncFetchReducer({
      initialState: INITIAL_STATE.orders,
      key         : 'order',
      init        : actions.order.fetch.type,
      success     : actions.order.fetchSuccess.type,
      error       : actions.order.fetchError.type,
    }),
    ...makeAsyncFetchReducer({
      initialState: INITIAL_STATE.update,
      key         : 'update',
      init        : actions.order.update.type,
      error       : actions.order.updateError.type,
      success     : [actions.order.updateSuccess.type,
        (state, { payload }) => mergeDeepLeft({
          order: {
            data: payload,
          },
          update: {
            loading: false,
            data   : true,
          },
        }, state)],
    }),
    ...makeAsyncFetchReducer({
      initialState: INITIAL_STATE.confirm,
      key         : 'confirm',
      init        : actions.order.confirm.type,
      error       : actions.order.confirmError.type,
      success     : [actions.order.confirmSuccess.type,
        mergeDeepLeft({
          order: {
            data: {
              status: ORDER_STATUS.CONFIRMED,
            },
          },
          confirm: {
            loading: false,
            data   : true,
          },
        })],
    }),
    ...makeAsyncFetchReducer({
      initialState: INITIAL_STATE.events,
      key         : 'events',
      init        : actions.order.events.type,
      error       : actions.order.eventsError.type,
      success     : [actions.order.eventsSuccess.type,
        mergeDeepLeft({
          events: {
            loading: false,
            data   : true,
          },
        })],
    }),
    [actions.order.resetEvents.type]: over(lensProp('events'), always(INITIAL_STATE.events)),
  },
});

export default reducer;
